import { render, staticRenderFns } from "./form-link.vue?vue&type=template&id=1a4e4cae&"
import script from "./form-link.vue?vue&type=script&lang=js&"
export * from "./form-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "form-link.vue"
export default component.exports